import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=0adf4da6&"
var script = {}
import style0 from "./faq.vue?vue&type=style&index=0&id=0adf4da6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports